/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../services/user.service';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';
import { ViewportScroller } from '@angular/common';


@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent  implements OnInit {

  @Output() addConversation: EventEmitter<{ newConversation:boolean,oldMessages?:any }> = new EventEmitter();
  constructor(public utilservice:UtilsService) { }
  @Input() question?:string=''
  @Input() id?:any
  @Input() isQuestionActive?:boolean=false
  @Input() activeQuestionColor?:string

  oldQuestion:string|undefined="";
  generatedSql:string="";
  generatedPrompt:string="";
  questionActive:boolean=false;

  questionBackround:string="user-mode-question"

  ngOnInit() {
    this.oldQuestion=this.question; 
    // this.questionBackround = this.utilservice.trainerMode ? '#F1D8BD' : '#CFCFCF';
  }
  updateStarredQuestion(isStarred:boolean){
    if(isStarred){
      this.utilservice.addStarredQuestion(this.question!)
    }
    else{
      this.utilservice.unStarredQuestion(this.question!)
    }

  }
  openMenu(){
    if(this.utilservice.trainedQuestions.length!==0 && this.utilservice.trainedQuestions.length!==undefined &&this.utilservice.trainerMode){
    this.isQuestionActive=!this.isQuestionActive
    this.utilservice.getTrainedPromptDetails(this.question!,this.id!)
    this.utilservice.activeTabIndex=this.isQuestionActive?0:1
    }
  }

}